import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Camera, CameraOff } from "lucide-react";

export const QrScanner = ({ onCode }) => {
  const [on, setOn] = useState(false);
  const [err, setErr] = useState("");
  const ref = useRef(null);
  const last = useRef({ code: "", at: 0 });
  const cb = useRef(onCode);
  cb.current = onCode;

  useEffect(() => {
    if (!on) return undefined;
    const q = new Html5Qrcode("qr-reader");
    ref.current = q;
    q.start({ facingMode: "environment" }, { fps: 10, qrbox: 230 }, (text) => {
      const now = Date.now();
      if (text === last.current.code && now - last.current.at < 4000) return;
      last.current = { code: text, at: now };
      cb.current(text);
    }).catch(() => { setErr("No pudimos abrir la cámara. Revisá los permisos o ingresá el código a mano."); setOn(false); });
    return () => { if (q.isScanning) q.stop().then(() => q.clear()).catch(() => {}); };
  }, [on]);

  return (
    <div className="rounded-3xl bg-[var(--ink)] p-4 text-white">
      <div id="qr-reader" data-testid="qr-reader" className={`overflow-hidden rounded-2xl ${on ? "min-h-[260px]" : "hidden"}`} />
      <button onClick={() => { setErr(""); setOn(!on); }} data-testid="scanner-toggle" className={`${on ? "mt-3 bg-white/10" : "bg-[var(--lime)] text-[var(--ink)]"} flex h-14 w-full items-center justify-center gap-2 rounded-2xl font-bold`}>
        {on ? <><CameraOff className="h-5 w-5" /> Detener cámara</> : <><Camera className="h-5 w-5" /> Escanear QR del pasaje</>}
      </button>
      {err && <p data-testid="scanner-error" className="mt-2 text-sm text-amber-300">{err}</p>}
    </div>
  );
};
